import React, { useState } from 'react';
import { Button } from './Button';
import { Card } from './Card';
import { XIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
export function PerDiemModal({
  isOpen,
  onClose,
  currentLocation,
  currentAmount
}) {
  const [location, setLocation] = useState(currentLocation);
  const [amount, setAmount] = useState(currentAmount);
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-79">
      <Card className="w-full max-w-md relative" data-id="element-80">
        <button onClick={onClose} className="absolute right-4 top-4 p-1 hover:bg-gray-100 rounded-full" data-id="element-81">
          <XIcon size={20} className="text-gray-500" data-id="element-82" />
        </button>
        <h2 className="text-xl font-bold mb-4" data-id="element-83">Adjust Per Diem Rate</h2>
        <div className="space-y-4" data-id="element-84">
          <div data-id="element-85">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-86">
              Location
            </label>
            <div className="relative" data-id="element-87">
              <MapPinIcon size={20} className="absolute left-3 top-2.5 text-gray-400" data-id="element-88" />
              <input type="text" value={location} onChange={e => setLocation(e.target.value)} className="pl-10 w-full p-2 border rounded-lg" placeholder="Enter city, state" data-id="element-89" />
            </div>
            <p className="text-sm text-gray-500 mt-1" data-id="element-90">
              Based on GSA published rates
            </p>
          </div>
          <div data-id="element-91">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-92">
              Daily Rate
            </label>
            <div className="relative" data-id="element-93">
              <span className="absolute left-3 top-2.5 text-gray-400" data-id="element-94">$</span>
              <input type="number" value={amount} onChange={e => setAmount(e.target.value)} className="pl-8 w-full p-2 border rounded-lg" data-id="element-95" />
            </div>
          </div>
          <div className="flex justify-end space-x-3 mt-6" data-id="element-96">
            <Button variant="outline" onClick={onClose} data-id="element-97">
              Cancel
            </Button>
            <Button onClick={onClose} data-id="element-98">Save Changes</Button>
          </div>
        </div>
      </Card>
    </div>;
}